import { ValueOf } from './util';

/** 性別のenum */
export const ESexType = {
  UNSPECIFIED: '指定なし',
  MALE: '男性',
  FEMALE: '女性',
  NOT_KNOWN: 'その他',
} as const;

export type SexTypeKey = keyof typeof ESexType;
export type SexTypeValue = ValueOf<typeof ESexType>;

export const sexTypeKeys = Object.keys(ESexType) as (SexTypeKey[]);

/** v-select用items */
export const sexTypeItems = sexTypeKeys
  .map((key) => ({
    title: ESexType[key],
    value: key,
  }));
